var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['statusBox', _vm.classes],style:({
    background: _vm.background,
    color: _vm.color,
    'box-shadow': _vm.boxShadow,
    '--tagColor': _vm.tagColor,
  })},[_vm._v(" "+_vm._s(_vm.statusTxt)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }